
<!--
  template for the <empty-state></empty-state> component
-->
<template lang="pug">
  .p-empty-state
    .p-empty-state__img(v-if="isImage")
      img(:src="getImage")
    .p-empty-state__title(v-if="title" v-html="title")
    .p-empty-state__message
      slot(name="body")
        div(v-if="message" v-html="message")
        slot(name="custumMessage")
    .p-empty-state__button(v-if="action && actionText")
      router-link.c-button.c-button--secondary.c-button--md.c-button-radius--corner(v-bind:to="action" v-html="actionText")

</template>

<script lang="babel">

  export default {
    name: "empty-state",
    props: {
      title: {
        type: String,
        default: null,
      },
      message: {
        type: String,
        default: null,
      },
      action: {
        type: Object,
        default: () => {
          return null
        },
      },
      actionText: {
        type: String,
        default: null,
      },
      isImage: {
        type: Boolean,
        default: true,
      },
      imagePath: {
        type: String,
        default: () => {
          return null
        },
      },
    },
    data () {
      return {
      }
    },
    created () {
    },
    beforeRouteUpdate (to, from, next) {
    },
    computed: {
      getImage () {
        if ( !this.isImage ) return null
        return this.imagePath !== null ? require(`${this.imagePath}`) : require('../assets/img/empty/emptyStateImg@2x.png')
      }
    },
    methods: {

    }
  }
</script>

<style lang="scss">

</style>
